import { App } from '@prisma/client'
import { FeatureAppClientShared } from '~/features/app/clientShared'
import { FeatureAppSessionClientShared } from '~/features/appSession/clientShared'
import { AppSessionType } from '~/features/appSession/common'
import { DataApp } from '../../hooks/useData'

type Props = {
  app: DataApp
  appSession: AppSessionType
}

export const useComputed = ({ app, appSession }: Props) => {
  const { hasOnboarding, isCorrupted: isOnboardingCorrupted } =
    FeatureAppSessionClientShared.useOnboarding({
      appSession,
    })

  const settings = FeatureAppClientShared.Helper.getUISettings(
    app as any as App,
  )

  const canTables = settings.sqlLite.isActive
  const canTasks = settings.task.isActive
  const canFiles = settings.driveFile.isActive
  const canPosts = settings.socialMediaPost.isActive
  const canEmailStyle = settings.executiveAssistant.isActive
  const canLeads = settings.salesLead.isActive
  const canBlogPosts = settings.blogPost.isActive
  const canTemplates = settings.templates.isActive
  const canStickyNotes = settings.stickyNotes.isActive
  const canKnowledges = settings.knowledges.isActive
  const tabNameFiles = settings.driveFile.tabName
  const tabNameTables = settings.sqlLite.tabName
  const tabNameTask = settings.task.tabName

  return {
    canTables,
    canTasks,
    canFiles,
    canPosts,
    canEmailStyle,
    canLeads,
    canBlogPosts,
    canTemplates,
    canStickyNotes,
    canKnowledges,
    tabNameFiles,
    tabNameTables,
    tabNameTask,
    isOnboardingCorrupted,
    hasOnboarding,
  }
}
